import React from "react";
import { connect } from "react-redux";
import { Container, Typography} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { withTheme } from "@mui/styles";
import { authHeader } from "../../_helpers";
import { withTranslation } from "react-i18next";
import { surveyActions } from "../../_actions";
import { themeBreakpointDown } from "../../_helpers/breakpointHelper";
import { flushSync } from "react-dom";
import ObjectsGrid from "./ObjectsGrid";
import { Box } from "@mui/material";
// import CreateSurveyDialog from "./CreateSurveyDialog";

const { webApiUrl } = window.appConfig;

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  dialogHeaderTitle: {
    fontSize: "14px !important",
    color: theme.palette.common.white,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(0.5),
    color: theme.palette.grey[500],
  },
  closeIcon: {
    fill: theme.palette.common.white,
    fontSize: 24,
  },

  grow: {
    flexGrow: 1,
  },
  bold: {
    fontWeight: "bold",
  },
  mainContainer: {
    height: "100%",
    width: "100%",
    overflow: "auto",
    padding: 0,
  },
  dataTable: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    "& > .MuiPaper-root": {
      flex: "0 1 auto",
    },
    "& > .MuiToolbar-root.MuiToolbar-regular": {
      display: "flex",
      "& > div": {
        padding: 0,
        textAlign: "right",
        flex: "1 0 auto",
        "& .MuiTypography-root": {
          textAlign: "left",
        },
      },
    },
    "& .MuiTableCell-root": {
      padding: theme.spacing(0),
      "&.MuiTableCell-paddingCheckbox": {
        paddingLeft: theme.spacing(0.5),
        "& > div": {
          justifyContent: "center",
        },
        "& .MuiCheckbox-root": {
          padding: theme.spacing(0.25),
        },
      },
      "&.MuiTableCell-head": {
        fontWeight: "bold",
      },
    },
  },
  fullWidth: {
    width: "100%",
  },
  dataSyncDialog: {
    "& .MuiPaper-rounded": {
      borderRadius: 10,
      minWidth: "384px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "270px",
      },
    },
  },
  dataSyncDialogContainer: {
    padding: theme.spacing(2),
  },
  recordButtonContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "25px 0 10px 0",
  },
  recordButton: {
    padding: theme.spacing(0.8, 6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.8, 5),
    },
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(0.8, 3),
    },
  },
  checkboxTitle: {
    marginBottom: 0,
    "& .MuiTypography-root": {
      fontSize: 12,
      fontWeight: "bold",
      color: theme.palette.common.black,
    },
  },
});

class Page extends React.Component {
  state = {
    buildings: [],
    columnsVisibility: [],
    rowsPerPage: 50,
    recordModal: false,
    date: new Date(),
    carriedOutBy: "",
    surveyType: "",
    dateSet: false,
    isLoading: true,
    getMessageCountsLoading: true,
    messageCountPerBuilding: [],
  };

  handleClick = () => {
    flushSync(()=>{this.setState({ recordModal: !this.state.recordModal });})
  };

  handleChange = (field, value) => {
    flushSync(()=>{this.setState((p) => ({ ...p, [field]: value }));})
  };

  componentDidMount() {
    const { selected } = this.props;

    var rowsPerPage = parseInt(localStorage.getItem("Objects_RowsPerPage"));
    if (!!rowsPerPage && rowsPerPage > 0 && rowsPerPage !== this.state.rowsPerPage) {
      this.setRowsPerPage(rowsPerPage);
    }

    if (selected) {
      this.UpdateBuildings();
      this.getMessageCountPerBuilding();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { selected } = this.props;
    const { messageCountPerBuilding } = this.state;
    if (!prevProps.selected || prevProps.selected.projectId !== selected.projectId || this.props.location.key !== prevProps.location.key) {
      flushSync(()=>{this.setState({ buildings: [], isLoading: true });})
      this.UpdateBuildings();
      this.getMessageCountPerBuilding();
    }
    if (this.state.buildings && prevState.messageCountPerBuilding !== this.state.messageCountPerBuilding) {
      const buildings = this.state.buildings;

      buildings.forEach((building) => {
        building.messageCount = 0;
        if (messageCountPerBuilding) {
          var obj = messageCountPerBuilding.find((x) => x.buildingId.toUpperCase() === building.buildingId.toUpperCase());
          if (obj) building.messageCount = obj.count;
        }
      });

      flushSync(()=>{this.setState({ buildings });})
    }
  }

  getMessageCountPerBuilding = () => {
    const { selected } = this.props;
    if (selected) {
      flushSync(()=>{this.setState({ getMessageCountsLoading: true });})
      const url = `${webApiUrl}api/Home/GetCountOfNewMessagesPerBuilding/${selected.projectId}`;
      const requestOptions = {
        method: "GET",
        headers: authHeader(),
      };

      fetch(url, requestOptions)
        .then((Response) => Response.json())
        .then((findResponse) => {
          flushSync(()=>{
            this.setState({
            messageCountPerBuilding: findResponse,
            getMessageCountsLoading: false,
          });
          })
        })
        .catch((er) => {
          console.log(er);
          flushSync(()=>{this.setState({ getMessageCountsLoading: false });})
        });
    }
  };

  setRowsPerPage = (rowsPerPage) => {
    flushSync(()=>{this.setState({ rowsPerPage });})

    localStorage.setItem("Objects_RowsPerPage", rowsPerPage);
  };

  isColumnVisible = (columnName) => {
    const { theme } = this.props;
    const { columnsVisibility } = this.state;
    const isSmallScreen = themeBreakpointDown(window, theme, "sm");

    var column = columnsVisibility.find((x) => x.name === columnName);
    if (column) {
      return column.visible;
    } else if (isSmallScreen) {
      return false;
    } else {
      return true;
    }
  };

  UpdateBuildings() {
    const { selected, buildings } = this.props;

    if (selected) {
      flushSync(()=>{
        this.setState({
        buildings: buildings ? buildings.filter((x) => x.projectId === selected.projectId) : [],
        isLoading: false,
      });
      })
    }
  }

  recordSaveHandler = () => {
    const { dispatch, selected } = this.props;
    const { date, carriedOutBy, surveyType, dateSet } = this.state;
    const obj = dateSet ? { date } : { date: new Date() };
    dispatch(
      surveyActions.addSurvey({
        ...obj,
        surveyType: +surveyType,
        buildingId: selected.buildingId,
        projectId: selected.projectId,
        status: 0,
        carriedOutBy,
        executorSignature: {
          name: "",
          content: "",
        },
        buyerRenter1Signature: {
          name: "",
          content: "",
        },
        buyerRenter2Signature: {
          name: "",
          content: "",
        },
      })
    );
    flushSync(()=>{
      this.setState({ recordModal: false });
    })
  };

  render() {
    const { t , classes} = this.props;
    const { buildings} = this.state;
    return (
      <Container maxWidth={false} className={classes.mainContainer}>
         <Box display="flex" flexDirection="column" sx={{ height: "100%" }}>
              <Box p={2} display={'flex'} alignItems={'center'} >
                <Typography variant='h6'>{t("general.objects")}</Typography>
                </Box>
                <Box sx={{ flex: 1 , minHeight: 0}}>
        {/* <CreateSurveyDialog
                    classes={classes}
                    handleChange={this.handleChange}
                    onClose={this.handleClick}
                    state={this.state}
                    onSave={this.recordSaveHandler}
                /> */}
        <ObjectsGrid   rows={buildings} />
        </Box>
      </Box>
      </Container>
      
    );
  }
}

function mapStateToProps(state) {
  const { authentication, buildings, availableSurveyModules = [] } = state;
  const { user } = authentication;
  const { selected, all } = buildings;
  return {
    user,
    selected,
    buildings: all,
    availableSurveyModules,
  };
}

const connectedPage = connect(mapStateToProps)(withTheme(withTranslation()(withStyles(styles)(Page))));
export { connectedPage as ObjectsPage };
